<template>
    <v-dialog v-model="dialog" max-width="500">
        <v-card style="border-radius: 10px;">
            <p class="dialog-header">
                <v-spacer />
                <v-icon @click="dialog = false" class="mx-1 my-1 white--text pointer">close</v-icon>
            </p>
            <v-card-text>
                <center>
                    <span v-html="$t('newVersion')"></span>
                </center>
            </v-card-text>
            <v-card-actions class="d-flex justify-center pl-15 pr-15">
                <v-btn color="info" @click="handleSubmit(true)" class="popup-btn rounded-btn">{{ $t('Обновить') }}</v-btn>
                <v-btn outlined @click="handleSubmit(false)" color="info" class="popup-btn rounded-btn">{{ $t('Отмена') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import UpdateCheckerMixin from '../../mixins/UpdateCheckerMixin';
export default {
    mixins: [UpdateCheckerMixin]
};
</script>
